import { SummaryOverviewItem } from "./summary_overview_item";
export const SummaryOverviewItems = (props) => {
  const items = props.items.map((item) => (
    <SummaryOverviewItem
      item={item[1]}
      quantity={item[2]}
      type={item[0]}
      removeFromCategorySelection={props.removeFromCategorySelection}
      removeImageUrl={props.removeImageUrl}
      completedSet={props.completedSet}
      handleQuantityChange={props.handleQuantityChange}
    />
  ));
  return (
    <table
      id="product-set-overview"
      style={{ width: "100%", marginBottom: 20 }}
    >
      <tbody>
        {items}
        <tr>
          <td colSpan="5" style={{ textAlign: "right", paddingRight: 17 }}>
            <table style={{ float: "right", marginTop: 15 }}>
              <tr>
                <td
                  style={{
                    color: "#4E4E4E",
                    textAlign: "right",
                    paddingRight: 10,
                  }}
                >
                  Běžná cena za tento set:
                </td>
                <td style={{ color: "#4E4E4E" }}>{props.totalPrice}</td>
              </tr>
              {props.showDiscountedPrice ? (
                <tr>
                  <td
                    style={{
                      color: "#4E4E4E",
                      textAlign: "right",
                      paddingRight: 10,
                    }}
                  >
                    Celkem ušetříte:
                  </td>
                  <td style={{ color: "#4E4E4E" }}>{props.totalDiscount}</td>
                </tr>
              ) : null}
              {props.showDiscountedPrice ? (
                <tr>
                  <td
                    style={{
                      color: "#2DA514",
                      fontWeight: "bold",
                      textAlign: "right",
                      paddingRight: 10,
                      paddingTop: 10,
                      fontSize: 23,
                    }}
                  >
                    Cena setu po slevě vč. 12% DPH:
                  </td>
                  <td
                    style={{
                      color: "#2DA514",
                      fontWeight: "bold",
                      paddingTop: 10,
                      fontSize: 23,
                    }}
                  >
                    {props.discountedTotalPrice}
                  </td>
                </tr>
              ) : null}
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  );
};
